import useSWR from "swr";

const fetcher = (...args) => fetch(...args).then((res) => res.json());

const CategoryDropdownL1 = ({ selectHandler, elValue}) => {
  const { data, error } = useSWR(`${process.env.REACT_APP_API_URL}/list_languages`, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  }); 
  
  if (error) {
    return <select
      className="min-w-[12rem] px-3 py-2 text-sm font-semibold"
    >
      <option value="Other" key="newother">L1L2map is unavailable</option>
    </select>
  }

  if (!data) {
    return <select
      className="min-w-[12rem] px-3 py-2 text-sm font-semibold"
      >
      <option value="Other" key="newother2">Loading list...</option>
    </select>
  }

  return <select
    className="min-w-[12rem] px-3 py-2 text-sm font-semibold"
    onChange={selectHandler}
    value={elValue}
  >     
    {data.result&&data.result.map((lang,i) => <option value={lang.name} key={String(lang.pk)+String(i)}>
      {lang.name}
    </option>)}
  </select>

};


export default CategoryDropdownL1;
